import React from 'react';
const logo = '/public/favicons/heart-cities.svg';

export default function BrandMark({className = 'brand-mark'}) {
    return <img src={logo} className={className} alt="" aria-hidden="true" width="40" height="40"/>;
}
